export default function Rewards() {
  const rewards = [
    { h: "Welcome 500 Petals", b: "Instantly credited on sign-up." },
    { h: "Birthday Bonanza", b: "Up to 5,000 Petals on your special day, plus complimentary cake and suite garlanding." },
    { h: "Membership Anniversary", b: "Bonus Petals on your Orchid Petals anniversary, every year." },
    { h: "Suite Upgrades", b: "Complimentary upgrades on availability for Platinum and Diamond members." },
    { h: "Private Previews", b: "First look at new property openings, signature menus and seasonal experiences." },
    { h: "Spa Indulgences", b: "Diamond-tier complimentary spa rituals at our signature wellness centres." },
    { h: "Late Check-out", b: "Guaranteed late check-out (4 PM) for Platinum and Diamond members." },
    { h: "Surprise Drops", b: "Curated dining vouchers and partner offers throughout the year." },
  ];
  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-12 py-20" data-testid="page-rewards">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">REWARDS</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-16">Beyond<br /><em className="font-light">the Petals.</em></h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {rewards.map((r) => (
          <div key={r.h} className="border border-black/10 bg-white p-7">
            <h3 className="font-display text-xl mb-2">{r.h}</h3>
            <p className="text-sm text-neutral-600 leading-relaxed">{r.b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
